export const GET_LANGUAGES = 'config::GET_LANGUAGES';
export const GET_LANGUAGES_REQUEST = 'config::GET_LANGUAGES_REQUEST';
export const GET_LANGUAGES_SUCCESS = 'config::GET_LANGUAGES_SUCCESS';
export const GET_LANGUAGES_FAILURE = 'config::GET_LANGUAGES_FAILURE';

export const SET_APP_STATE = 'config::SET_APP_STATE';

export const SET_INITIAL_WEB_PATHNAME = 'config::SET_INITIAL_WEB_PATHNAME';

export const SET_REDUCE_MOTION_ENABLED = 'config::SET_REDUCE_MOTION_ENABLED';
export const SET_SCREEN_READER_ENABLED = 'config::SET_SCREEN_READER_ENABLED';

export const GET_CONSENT_ORDERING = 'config::GET_CONSENT_ORDERING';
export const SET_CONSENT_ORDERING = 'config::SET_CONSENT_ORDERING';
export const SET_DIDOMI_USER_STATUS = 'config::SET_DIDOMI_USER_STATUS';

export const SET_SPLASH_SCREEN_STATE = 'config::SET_SPLASH_SCREEN_STATE';
